/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Group_TodayInputs */

const en_notifications_group_today = /** @type {(inputs: Notifications_Group_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const pl_notifications_group_today = /** @type {(inputs: Notifications_Group_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziś`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Notifications_Group_TodayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_group_today = /** @type {((inputs?: Notifications_Group_TodayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Group_TodayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_group_today(inputs)
	return en_notifications_group_today(inputs)
});